import { render } from "./LocalModal.vue?vue&type=template&id=58bb3ecf&scoped=true"
import script from "./LocalModal.vue?vue&type=script&lang=js"
export * from "./LocalModal.vue?vue&type=script&lang=js"

import "./LocalModal.vue?vue&type=style&index=0&id=58bb3ecf&lang=scss&scoped=true"

import exportComponent from "../../../../../DIARC/pixonanimation.az/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58bb3ecf"]])

export default __exports__